import { validationRules } from "../../utils/validation";

export const clientCounterPartySchema = {
    clientType: [
        validationRules.required("What involvement does the entity have in the transaction? is required"),
    ],
    entityType: [
        validationRules.required("Entity Role is required"),
    ],
    companyName: [
        validationRules.required("Company Name is required"),
    ],
    countryOfIncorporation: [
        validationRules.required("Country of Incorporation is required"),
    ],
    companyType: [
        validationRules.required("Company Type is required"),
    ],
    registrationNumber: [
        validationRules.required("Registration Number is required"),
    ],
    addressLine1: [
        validationRules.required("Registered Office Address Line 1 is required"),
    ],
    postCode: [
        validationRules.required("Registered Office Postcode is required"),
    ],
    overseasEntities: [
        validationRules.required("Is client listed on the Register of Overseas Entities is required"),
    ],
    isRegulatoryListed: [
        validationRules.required("Is client regulated by a recognised regulatory body is required"),
    ],
    isBillingRecognized: [
        validationRules.required("Is Billing Entity listed on a recognised exchange is required"),
    ],
    relianceFromThirdParty: [
        validationRules.required("Are you taking reliance from a third party is required")
    ]

}

export const overSeasEntitiesYesSchema = {
    overseasEntitiesNumber: [
        validationRules.required("Registered Overseas Entities Number is required"),
    ],
}


export const isRegulatoryListedYesSchema = {
    regulatoryBody: [
        validationRules.required("Select Regulatory Body."),
    ],
    regulatoryReferenceNumber: [
        validationRules.required("Regulatory Reference Number is required"),
    ],
}

export const isBillingRecognizedYesSchema = {
    recognisedExchange: [
        validationRules.required("Select Recognized Exchange")
    ],
}

export const complyWithRegulationsSchema = {
    regulatoryBodyAutorizedBy: [
        validationRules.required("Select Which regulatory body is the entity authorised by?"),
    ],
}